import React, { useEffect, useRef } from 'react';

import type { OptionsFromRequest } from '../../../../core/system/rendering/types.js';
import type { FrapiList } from '../../../types/frapi-types.js';

import {
  withByfunnPulse,
  useByfunnPulseContext,
} from '../../../pulse/index.js';
import { ListPageV1 } from './ListPageV1.js';
import { ListPageV2 } from './ListPageV2.js';
import { isListOfTeasers } from './TopList/guards.js';

export type ListPageProps = {
  data: FrapiList;
  options: OptionsFromRequest;
};

const ListPage: React.FC<ListPageProps> = (props) => {
  const { data, options } = props;

  const ref = useRef<HTMLDivElement>(null);

  const { registerViewElementTracking, registerPageLeaveTracking } =
    useByfunnPulseContext();

  useEffect(() => {
    registerViewElementTracking();

    if (ref.current) {
      registerPageLeaveTracking({ objectElement: ref.current });
    }
  }, [registerViewElementTracking, registerPageLeaveTracking]);

  const isMobile = options.siteVersion === 'phone';
  const isTopList = isListOfTeasers(data.items);

  return (
    <div ref={ref}>
      {isTopList && isMobile ? (
        <ListPageV2 {...props} />
      ) : (
        <ListPageV1 {...props} isTopList={isTopList} />
      )}
    </div>
  );
};

const ListPageWithPulse = withByfunnPulse(ListPage);

export { ListPageWithPulse as ListPage };
